import * as React from "react"

interface CodaIconProps {
  width?: number | string;
  height?: number | string;
  [key: string]: any;
}

const CodaIcon = ({ width = 39.4, height = 42, ...props }: CodaIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 39.4 42" {...props}>
    <path
      fill="#EE5A29"
      d="M30.5,11.3c2.3,0,4.5,0.9,6.1,2.3c1.1,0.9,2.7,0.2,2.7-1.3v-9C39.3,1.5,37.9,0,36,0H3.3C1.5,0,0,1.5,0,3.3v35.5C0,40.5,1.5,42,3.3,42h32.8c1.8,0,3.3-1.5,3.3-3.3v-9c0-1.4-1.6-2.2-2.7-1.3c-1.7,1.5-3.8,2.3-6.1,2.3c-5.3,0-9.6-4.4-9.6-9.7C21,15.7,25.3,11.3,30.5,11.3z"
    />
  </svg>
)

export default CodaIcon
